import React from "react";
import {IconButton, type IconButtonProps, Skeleton} from "@mui/material";
import ArrowUpIcon from "~/icons/svg/ArrowUpIcon.svg?react";
import {composerButtonSx} from "~/pages/chat-agent/components/ChatInput/composerButton.styles";

type Props = Omit<IconButtonProps, "sx"> & {loading: boolean};

/** The composer's round send button at its top-right corner; a skeleton while the composer loads. */
export const SendButton: React.FC<Props> = ({loading, ...props}) => {
    if (loading) {
        return (
            <Skeleton
                variant="circular"
                width={36}
                height={36}
                sx={{
                    position: "absolute",
                    right: "16px",
                    top: "16px",
                }}
            />
        );
    }
    return (
        <IconButton {...props} sx={composerButtonSx}>
            <ArrowUpIcon/>
        </IconButton>
    );
};
